<template>
  <ul class="ai-key-points text-body-2">
    <li v-for="(point, index) in points" :key="index">
      {{ point.text }}
      <router-link
        v-for="reportId in point.report_ids"
        :key="reportId"
        :to="`/accounts/${accountId}/reports/${reportId}`"
        class="text-caption ml-1"
        :title="
          point.quote ? `Uit het rapport: “${point.quote}”` : 'Rapport bekijken'
        "
        >bron</router-link
      >
      <span
        v-if="point.reference === 'unconfirmed'"
        class="text-caption text-medium-emphasis ml-1"
        title="De AI gaf een bron op, maar de aangehaalde woorden staan in geen van de rapporten. Controleer dit punt zelf."
      >
        (bron niet gevonden)
      </span>
      <template v-if="showChecks">
        <v-chip
          v-if="referenceChip(point)"
          size="x-small"
          variant="tonal"
          :color="referenceChip(point).color"
          class="ml-1"
        >
          {{ referenceChip(point).label }}
        </v-chip>
        <div v-if="point.quote" class="text-caption text-medium-emphasis">
          Aangehaald: “{{ point.quote }}”
        </div>
      </template>
    </li>
  </ul>
</template>

<script setup>
/**
 * The key points of an AI summary of a person, each with links to the reports it is
 * based on. A reference is only shown when the words the AI quoted really are in
 * that report (checked on the server); a point without one says so.
 */
import { briefingReference } from "@/utils/aiRequests";

defineProps({
  // [{ text, report_ids, quote?, reference? }]
  points: { type: Array, default: () => [] },
  accountId: { type: [Number, String], required: true },
  // Quality control: also show how each reference held up and the quoted words
  showChecks: { type: Boolean, default: false },
});

const referenceChip = (point) => briefingReference(point.reference);
</script>

<style scoped>
.ai-key-points {
  padding-left: 1.25rem;
}
</style>
